"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.loadScript = loadScript;

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/promise"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function loadScript(id, url) {
  var ignorePreviousError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return new _promise.default(function (resolve, reject) {
    function handleLoad() {
      var _context;

      if (this.readyState && !(0, _includes.default)(_context = ['loaded', 'complete']).call(_context, this.readyState)) {
        return;
      }

      this.setAttribute('data-state', 'loaded');
      resolve();
    }

    function handleError() {
      this.setAttribute('data-state', 'error');
      reject();
    }

    function innerLoadScript() {
      var $head = document.getElementsByTagName('head')[0];
      var $script = document.createElement('script');
      $script.setAttribute('type', 'text/javascript');
      $script.setAttribute('id', id);
      $script.setAttribute('src', url);
      $script.setAttribute('data-state', 'loading');
      $script.addEventListener('load', handleLoad);
      $script.addEventListener('error', handleError);
      $script.addEventListener('readystatechange', handleLoad);
      $head.appendChild($script);
    }

    var $prevScript = document.getElementById(id);

    if (!$prevScript) {
      innerLoadScript();
      return;
    }

    switch ($prevScript.getAttribute('data-state')) {
      case 'loading':
        {
          $prevScript.addEventListener('load', handleLoad);
          $prevScript.addEventListener('error', handleError);
          $prevScript.addEventListener('readystatechange', handleLoad);
          break;
        }

      case 'loaded':
        {
          resolve();
          break;
        }

      case 'error':
        {
          if (ignorePreviousError) {
            $prevScript.remove();
            innerLoadScript();
          } else {
            reject();
          }

          break;
        }
    }
  });
}